var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('span',{staticClass:"string"},[_vm._v(_vm._s(_vm.value))]):(_vm.value === '')?_c('span',{staticClass:"string empty"},[_vm._v("Empty")]):_c('span',{staticClass:"string null"},[_vm._v("NULL")])}
var staticRenderFns = []

export { render, staticRenderFns }